import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21.06,10.29,5,.56A2,2,0,0,0,2,2.28V21.72a2,2,0,0,0,1,1.75,2.06,2.06,0,0,0,2,0l16-9.73a2,2,0,0,0,0-3.42Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }